// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__wK3cg"};